// Track button clicks for both Meta and LinkedIn
const trackButtonClick = () => {
  // Meta Pixel tracking
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("trackCustom", "ButtonClick");
  }

  // LinkedIn Insight Tag tracking
  if (typeof window !== "undefined" && window.lintrk) {
    window.lintrk("track", { conversion_id: 20530724 });
  }
};

export { trackButtonClick };
